import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import firebase from 'firebase/app';
import 'firebase/database';
import FontAwesome from 'react-fontawesome';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import UserEditDialog from './user-edit-dialog';
import RoleOptions from './role-options';

/** @class ActiveUserList
  * A component for displaying the active (have signed in at least once)
  * users of the Vexpo Admin Platform.  It also allows limited editing of
  * the users' information.
  * @prop {Array} users - the list of users to display
  */
export default class ActiveUserList extends ReactFireComponent {
  /** @constructor
    * Constructs a new ActiveUserList.
    */
  constructor(props) {
    super(props);
    this.state = {selectedUser: null}
    this.handleEmail = this.handleEmail.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }
  /** @method handleEmail
    * Sends a new login link email to a user
    * @param {string} uid - the user to send the link to.
    */
  handleEmail(uid) {
    const user = this.props.users.find(user => {
      return user.id === uid;
    });
    if(user && user.email) {
      const actionCodeSettings = {
        url: 'https://admin.vexposhows.com/',
        handleCodeInApp: true
      };
      firebase.auth().sendSignInLinkToEmail(user.email, actionCodeSettings)
      .then(() => window.alert(`Login link email sent to ${user.name} at ${user.email}`))
      .catch((error) => {
        window.alert(`Error sending login link email to ${user.name} at ${user.email}: ${error.code}`);
        console.error(error);
      });
    }
  }
  /** @method handleEdit
    * Allows the selection of a user from the list to edit.
    * @param {string} uid - the identity of the user to edit
    */
  handleEdit(uid) {
    this.setState({selectedUser: uid});
  }
  /** @method handleRemove
    * Allows the removal of a user from the list.  This permanently
    * removes their role permissions.
    * @param {string} uid - the identifier of the user
    */
  handleRemove(uid) {
    if(window.confirm("Are you sure?  This will permanently revoke this users' permissions and remove them from the Vexpo Admin Platform.")) {
      firebase.database().ref(`/users/${uid}`).set(null);
    }
  }
  /** @method render
    * Renders the component
    */
  render() {
    const columns = [
      {Header: 'Name', accessor: 'name'},
      {Header: 'Role', accessor: 'role',
        filterMethod: (filter, row) => {
          if(filter.value === "all") return true;
          else return filter.value === (row["role"])
        },
        Filter: ({filter, onChange}) => (
          <select
            onChange={event => onChange(event.target.value)}
            style={{width: "100%"}}
            value={filter ? filter.value : "All"}
          >
            <option name="all">All</option>
            <RoleOptions/>
          </select>
        )
      },
      {Header: 'Email', accessor: 'email', Cell: row => (
        <a href={`mailto://${row.value}`}>{row.value}</a>
      )},
      {Header: '', accessor: 'id', Cell: row => (
        <div style={{textAlign:'right'}}>
          <FontAwesome name="envelope"
            style={{color:'green', cursor: 'pointer'}}
            onClick={() => this.handleEmail(row.value)}/>
          <FontAwesome name="edit"
            style={{color:'orange', cursor: 'pointer'}}
            onClick={() => this.handleEdit(row.value)}/>
          <FontAwesome name="times"
            style={{color:'red', cursor: 'pointer'}}
            onClick={() => this.handleRemove(row.value)}/>
        </div>
      ),
      filterable: false}
    ]
    const selectedUser = this.props.users.find(user => {
      return user.id === this.state.selectedUser;
    });
    const userEdit = selectedUser
      ? <UserEditDialog
        user={selectedUser}
        show={true}
        onExit={()=>this.setState({selectedUser: null})}
        />
      : '';
    const style = {
      width: '100%',
      maxWidth: '600px'
    }
    return (
      <div>
        {userEdit}
        <h3 style={{marginBottom: 0}}>Active Users</h3>
        <ReactTable
          className="-striped"
          data={this.props.users}
          columns={columns}
          defaultPageSize={15}
          style={style}
          filterable
          />
      </div>
    )
  }
}

ActiveUserList.propTypes = {
  users: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/user-list/active-user-list.js